import { Link, useParams } from "react-router-dom";
import { Header, Footer } from "../index";
import { useEffect, useState } from "react";
import { ProductDetailsBySlugService } from "../../services/MainScreen";
import { Swiper, SwiperSlide } from "swiper/react";
import "swiper/css/free-mode";
import "swiper/css/navigation";
import "swiper/css/thumbs";
import { Autoplay } from "swiper/modules";
import "swiper/swiper-bundle.css";
import { formatNumber } from "../../utility/Formater";
import ProductSliderComponentChild from "../index/productSliderComponent/ProductSliderComponentChild";
import { isTokenValid } from "../../utility/Cookies";
import GalleryProduct from "./component/GalleryProductComponent";
import AddToCardProductDetailsComponent from "./component/AddToCardProductDetailsComponent";
import CommentProductComponent from "./component/CommentProductComponent";
import {
  HOME_URL_LOCAL,
  SEARCH_PRODUCT_URL_LOCAL,
} from "../../utility/BaseUrl";

const ProductDetails = ({ data, setData }) => {
  const { slug } = useParams();
  const [productData, setProductData] = useState({
    product: {},
    tags: [],
    galleries: [],
    productAttr_of_product: [],
    comments: [],
    related_products: [],
    productCategory_of_product: [],
    quantity: 0,
    averageRating: 0,
  });
  useEffect(() => {
    window.scrollTo(0, 0);
    const fetchDataAsync = async () => {
      let data = await ProductDetailsBySlugService(slug);
      setProductData({
        product: data.product_details,
        tags: data.product_details.tags,
        galleries: data.product_details.galleries,
        productAttr_of_product: data.product_details.productAttr_of_product,
        productCategory_of_product:
          data.product_details.productCategory_of_product,
        comments: data.product_details.comments,
        related_products: data.related_products,
        quantity: data.product_details.inventory_of_product.quantity,
        averageRating:
          data.product_details.comments.length > 0
            ? data.product_details.comments.reduce(
                (sum, comment) => sum + comment.rate,
                0
              ) / data.product_details.comments.length
            : 0,
      });
    };
    fetchDataAsync();
  }, [slug]);

  if (productData.product)
    return (
      <>
        <div>
          {/* search overlay */}
          <div className="header-search-overlay" />
          {/*main*/}
          <main className="product-container">
            <div className="container">
              <div className="product-context">
                <div className="bg-white rounded mt-4 px-2">
                  <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                      <Link to={HOME_URL_LOCAL} className="text-muted">
                        <span className="d-flex align-items-center">
                          <i
                            className="fa fa-home text-primary breadcrumb-home-icon d-inline-flex ml-10 position-relative text-xl"
                            aria-hidden="true"
                          />
                          خانه
                        </span>
                      </Link>
                    </li>
                    {productData.productCategory_of_product.length > 0 ? (
                      <li className="breadcrumb-item">
                        <Link
                          to={
                            SEARCH_PRODUCT_URL_LOCAL +
                            "?category=" +
                            productData.productCategory_of_product[0].category
                              .title
                          }
                          className="text-muted"
                        >
                          <span>
                            {
                              productData.productCategory_of_product[0].category
                                .title
                            }
                          </span>
                        </Link>
                      </li>
                    ) : null}
                    {productData.productCategory_of_product.length > 1 ? (
                      <li className="breadcrumb-item">
                        <Link
                          to={
                            SEARCH_PRODUCT_URL_LOCAL +
                            "?category=" +
                            productData.productCategory_of_product[1].category
                              .title
                          }
                          className="text-muted"
                        >
                          <span>
                            {
                              productData.productCategory_of_product[1].category
                                .title
                            }
                          </span>
                        </Link>
                      </li>
                    ) : null}
                    <li className="breadcrumb-item active">
                      <span>{productData.product.product_name}</span>
                    </li>
                  </ol>
                </div>
                <div className="product-header">
                  <div className="row">
                    <div className="col-xl-4">
                      <GalleryProduct product={productData.product} />
                    </div>
                    <div className="col-xl-8">
                      <form name="addtocart" className="product-info">
                        <div className="product-data p-15 rounded">
                          <div className="d-flex justify-content-between">
                            <div>
                              <h1 className="product-title">
                                {productData.product.product_name}
                              </h1>
                            </div>
                            <div
                              class="product-rating ng-scope"
                              eval="collect(170214583, 5, 1)"
                              product-rating=""
                              auto-show=""
                              style={{ display: " block" }}
                            >
                              {/* <a
                                role="button"
                                class="product-rating-link"
                                ng-click="submit(number)"
                                ng-focus="changeRate(number)"
                                ng-mouseover="changeRate(number)"
                                ng-mouseleave="changeRate()"
                                ng-repeat="number in [1,2,3,4,5]"
                              >
                                <i
                                  class="fa fa-star fa-flip-horizontal text-warning product-rating-link-icon"
                                  ng-class="{ 'fa-star-half-o': isHalf(number), 'fa-star-o': model.rate <= number-1 }"
                                ></i>
                              </a> */}
                              {productData.comments.length > 0 ? (
                                <div
                                  class="product-rating-info"
                                  ng-show="model.count"
                                >
                                  <div
                                    style={{ fontSize: "60%" }}
                                    class="ng-binding"
                                  >
                                    ( دیدگاه کاربراه{" "}
                                    {productData.comments.length} )
                                  </div>
                                </div>
                              ) : null}
                            </div>
                          </div>
                        </div>
                        <div className=" d-none d-md-block">
                          <div className="product-mini-fields-title mt-20 mb-10">
                            ویژگی‌های محصول
                          </div>
                          <ul className="product-mini-fields mb-20 p-0">
                            {productData.productAttr_of_product.map(
                              (item, index) => {
                                return (
                                  <li
                                    key={index}
                                    className="product-mini-fields-item mb-10"
                                  >
                                    {item.attribute_value} :
                                    {item.category_attribute.attribute_name}
                                  </li>
                                );
                              }
                            )}
                            <li
                              className="product-mini-fields-item mb-10"
                              dangerouslySetInnerHTML={{
                                __html: productData.product.short_description,
                              }}
                            />
                          </ul>
                        </div>
                        <div className="product-info-buy p-0 p-md-15">
                          <div className="product-price-wrap p-0 p-md-15">
                            {productData.product.inventory_of_product ? (
                              productData.product.inventory_of_product
                                .discount_percent > 0 ? (
                                <h5 class="product-discount">
                                  {
                                    productData.product.inventory_of_product
                                      .discount_percent
                                  }
                                  %
                                </h5>
                              ) : null
                            ) : null}

                            {productData.product.inventory_of_product ? (
                              productData.product.inventory_of_product
                                .discount_percent > 0 ? (
                                <h5 className="product-compare-price">
                                  {" "}
                                  {formatNumber(
                                    productData.product.inventory_of_product
                                      .product_sales_price
                                  )}{" "}
                                  تومان
                                </h5>
                              ) : null
                            ) : null}
                            <h5 className="product-price">
                              {productData.product.inventory_of_product
                                ? formatNumber(
                                    productData.product.inventory_of_product
                                      .final_price
                                  )
                                : null}{" "}
                              تومان
                            </h5>
                          </div>
                          <div className="product-buttons align-items-center d-block d-md-flex">
                            <div className="product-availability btn d-none d-md-inline-block border border-light rounded p-10 ml-2">
                              {productData.product.inventory_of_product ? (
                                productData.product.inventory_of_product
                                  .quantity > 0 ? (
                                  <span className="text-green">
                                    <i className="fa fa-check" />
                                    آماده ارسال
                                  </span>
                                ) : (
                                  <span className="text-red">
                                    <i className="fa fa-close" />
                                    ناموجود
                                  </span>
                                )
                              ) : null}
                            </div>
                            <AddToCardProductDetailsComponent
                              product={productData.product}
                              setData={setData}
                            />
                          </div>
                        </div>

                        {/* product features */}
                        <div className="product-features pt-20 d-none d-md-block">
                          <div className="row justify-content-center">
                            <div className="col-3 col-md col-lg">
                              <div className="product-features-item d-flex align-items-center mb-15">
                                <img
                                  src="/themes/custom-1a98/userfiles/df456e.svg?m=thumb&w=24&h=24&q=high"
                                  alt="۷ روز مهلت تست سلامت"
                                  className="product-features-item-image ml-10"
                                />
                                <span className="product-features-item-title d-block">
                                  ۷ روز مهلت تست سلامت
                                </span>
                              </div>
                            </div>
                            <div className="col-3 col-md col-lg">
                              <div className="product-features-item d-flex align-items-center mb-15">
                                <img
                                  src="/themes/custom-1a98/userfiles/3dc648.svg?m=thumb&w=24&h=24&q=high"
                                  alt="ضمانت اصل بودن کالا"
                                  className="product-features-item-image ml-10"
                                />
                                <span className="product-features-item-title d-block">
                                  ضمانت اصل بودن کالا
                                </span>
                              </div>
                            </div>
                            <div className="col-3 col-md col-lg">
                              <div className="product-features-item d-flex align-items-center mb-15">
                                <img
                                  src="/themes/custom-1a98/userfiles/7b55da.svg?m=thumb&w=24&h=24&q=high"
                                  alt="تحویل در کوتاهترین زمان"
                                  className="product-features-item-image ml-10"
                                />
                                <span className="product-features-item-title d-block">
                                  تحویل در کوتاهترین زمان
                                </span>
                              </div>
                            </div>
                          </div>
                        </div>
                      </form>
                    </div>
                  </div>
                </div>
                {/* <div className="product-description d-none">
                  <p className="product-description-content">
                    TASCAM Sonicview یک خط کاملاً جدید از کنسول های میکس دیجیتال
                    ایجاد کرده است این کنسول دیجیتال جدیدترین فناوری های دنیای
                    صدا را در خود جای داده و امکان مشاهده و کنترل تمام
                    پارامترهای مورد نظر اپراتور را در زمان دلخواه فراهم کرده است
                    این میکسر دیجیتال فوق العاده با امکانات بینظیر از جمله
                    پردازشگر سیگنال 54 بیتی FPGA با نقطه شناور ، دو صفحه نمایش
                    تمام تاچ 7 اینچی ،فیدرهای موتورایز 11 سانتی ، شبکه داخلی
                    Dante ، رابط صوتی USB چند کاناله با سمپل ریت 32 بیتی/96
                    کیلوهرتزی و ... صدایی بدون ایراد و با کیفیت فوق العاده بالا
                    را با کاربری بسیار آسان در اختیار کاربران حرفه ای خود قرار
                    میدهد .
                  </p>
                </div> */}
                <div className="products-wrap mb-30 mt-20">
                  <h2 className="products-title">
                    <span>محصولات مرتبط</span>
                  </h2>
                  <div className="owl-container position-relative">
                    <Swiper
                      className="products-items "
                      spaceBetween={10}
                      autoplay={{
                        delay: 4000,
                        disableOnInteraction: false,
                      }}
                      speed={300}
                      loop={true}
                      dir="rtl"
                      modules={[Autoplay]}
                      breakpoints={{
                        0: {
                          slidesPerView: 1.3,
                        },
                        375: {
                          slidesPerView: 2,
                        },
                        576: {
                          slidesPerView: 3,
                        },
                        992: {
                          slidesPerView: 4,
                        },
                      }}
                    >
                      {productData.related_products.map((item, index) => {
                        return (
                          <SwiperSlide
                            key={`product_slider_${data.id + index}`}
                          >
                            <ProductSliderComponentChild
                              item={item}
                              setData={setData}
                            />
                          </SwiperSlide>
                        );
                      })}
                    </Swiper>
                    {/* <div
                      className="products-items owl-carousel"
                      options="{
									  autoplay: true,
									  autoplayTimeout: 4500,
									  autoplayHoverPause: true,
									  smartSpeed: 500,
									  loop: true,
									  rtl: true,
									  margin: 10,
									  responsive:{ 0:{ items: 1.3 }, 375: { items: 2 }, 576: { items: 3 }, 992: { items: 4 }, 1200: { items: 6 } }
									  }"
                    > */}
                    {/* <div className="products-item position-relative bg-white rounded p-15 ">
                        <div className="products-item-image">
                          <a
                            href="/midas-m32-live"
                            className="products-item-link"
                          >
                            <img
                              src="/uploads/products/28e84a.jpg?m=crop&w=500&h=500&q=high"
                              className="img-fluid center-block products-item-image-element"
                              alt="میکسر دیجیتال MIDAS M32 LIVE"
                            />
                          </a>
                        </div>
                        <div className="products-item-price-wrap"> */}
                    {/* <if terms="nope">
				<span class="products-item-compare-price">
					0
				</span>
			</if>  */}
                    {/* <span className="products-item-price">
                            246,000,000 <span>تومان</span>
                          </span>
                        </div>
                        <h3 className="products-item-title">
                          <a
                            href="/midas-m32-live"
                            className="products-item-link"
                          >
                            میکسر دیجیتال MIDAS M32 LIVE
                          </a>
                        </h3> */}
                    {/*<div class="d-flex justify-content-between align-items-center">
		<button class="btn product-item-quick-view" ng-click="quickview(159741088, '/site/cart')">
			<if terms="nope">
				<svg width="1em" height="1em" viewBox="0 0 16 16" class="" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" d="M3.925 1.745a.636.636 0 0 0-.951-.059l-.97.97c-.453.453-.62 1.095-.421 1.658A16.47 16.47 0 0 0 5.49 10.51a16.471 16.471 0 0 0 6.196 3.907c.563.198 1.205.032 1.658-.421l.97-.97a.636.636 0 0 0-.06-.951l-2.162-1.682a.636.636 0 0 0-.544-.115l-2.052.513a1.636 1.636 0 0 1-1.554-.43L5.64 8.058a1.636 1.636 0 0 1-.43-1.554l.513-2.052a.636.636 0 0 0-.115-.544L3.925 1.745zM2.267.98a1.636 1.636 0 0 1 2.448.153l1.681 2.162c.309.396.418.913.296 1.4l-.513 2.053a.636.636 0 0 0 .167.604L8.65 9.654a.636.636 0 0 0 .604.167l2.052-.513a1.636 1.636 0 0 1 1.401.296l2.162 1.681c.777.604.849 1.753.153 2.448l-.97.97c-.693.693-1.73.998-2.697.658a17.47 17.47 0 0 1-6.571-4.144A17.47 17.47 0 0 1 .639 4.646c-.34-.967-.035-2.004.658-2.698l.97-.969z"/>
				</svg>
			</if>
			<if terms="yep">
				<svg width="1em" height="1em" viewBox="0 0 16 16" class="" fill="currentColor" xmlns="http://www.w3.org/2000/svg">
					<path fill-rule="evenodd" d="M0 2.5A.5.5 0 0 1 .5 2H2a.5.5 0 0 1 .485.379L2.89 4H14.5a.5.5 0 0 1 .485.621l-1.5 6A.5.5 0 0 1 13 11H4a.5.5 0 0 1-.485-.379L1.61 3H.5a.5.5 0 0 1-.5-.5zM3.14 5l1.25 5h8.22l1.25-5H3.14zM5 13a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0zm9-1a1 1 0 1 0 0 2 1 1 0 0 0 0-2zm-2 1a2 2 0 1 1 4 0 2 2 0 0 1-4 0z"/>
				</svg>
			</if>
		</button>
		<div class="product-rating" eval="collect(159741088, 4, 1)" product-rating auto-show>
			<span role="button" class="product-rating-link" ng-click="submit(number)" ng-focus="changeRate(number)" ng-mouseover="changeRate(number)" ng-mouseleave="changeRate()" ng-repeat="number in [1,2,3,4,5]">
				<i class="fa fa-star fa-flip-horizontal text-warning product-rating-link-icon" ng-class="{ 'fa-star-half-o': isHalf(number), 'fa-star-o': model.rate < number }"></i>
			</span>
		</div>
	</div>*/}
                    {/* </div> */}

                    {/* </div> */}
                  </div>
                </div>
                <div className="product-details">
                  <div className="product-details-tabs-container">
                    <ul
                      className="nav nav-tabs product-details-tabs p-10 mx-n10 mt-10 border-0"
                      role="tablist"
                    >
                      <li className="nav-item product-details-tab">
                        <Link
                          role="button"
                          className="nav-link product-details-tab-link active"
                          data-toggle="tab"
                          data-target="#product-content-0"
                        >
                          نقد و بررسی
                        </Link>
                      </li>
                      {/* <li className="nav-item product-details-tab">
                        <a
                          role="button"
                          className="nav-link product-details-tab-link"
                          data-toggle="tab"
                          data-target="#product-fields"
                        >
                          مشخصات
                        </a>
                      </li> */}

                      <li class="nav-item product-details-tab">
                        <Link
                          role="button"
                          class="nav-link product-details-tab-link"
                          data-toggle="tab"
                          data-target="#product-comments"
                        >
                          دیدگاه‌ها
                        </Link>
                      </li>
                    </ul>
                  </div>
                  <div className="tab-content">
                    <div className="tab-pane active" id="product-content-0">
                      <div
                        className="product-content figure-content"
                        dangerouslySetInnerHTML={{
                          __html: productData.product.long_description,
                        }}
                      />
                    </div>
                    <div className="tab-pane" id="product-comments">
                      <CommentProductComponent productData={productData} />
                    </div>
                    {/* <div className="tab-pane" id="product-fields">
                      <div className="product-fields">
                        <div className="row no-gutters product-field">
                          <div className="col-lg-3">
                            <h6 className="product-field-name">
                              مشخصات فیزیکی
                            </h6>
                          </div>
                          <div className="col-lg-9">
                            <div className="product-field-value">
                              ابعاد : 22*55*47 سانتی متر
                            </div>
                            <div className="product-field-value">
                              وزن : 13 کیلوگرم
                            </div>
                            <div className="product-field-value">
                              جنس بدنه : فلز
                            </div>
                          </div>
                        </div>
                        <div className="row no-gutters product-field">
                          <div className="col-lg-3">
                            <h6 className="product-field-name">مشخصات فنی</h6>
                          </div>
                          <div className="col-lg-9">
                            <div className="product-field-value">
                              نوع میکسر : دیجیتال
                            </div>
                            <div className="product-field-value">
                              تعداد کانال : 44
                            </div>
                            <div className="product-field-value">
                              تعداد ورودی میکروفون : 16 ورودی XLR
                            </div>
                            <div className="product-field-value">
                              تعداد خروجی : 16 خروجی XLR
                            </div>
                            <div className="product-field-value">
                              تعداد ورودی استریو : 2 کانال استریو RCA
                            </div>
                            <div className="product-field-value">
                              خروجی مستر : 1 کانال L\R
                            </div>
                            <div className="product-field-value">
                              خروجی هدفون : 1 کانال با ولوم مجزا
                            </div>
                            <div className="product-field-value">
                              سایر ورودی و خروجی ها : DANTE و SLOT و USB
                            </div>
                          </div>
                        </div>
                        <div className="row no-gutters product-field">
                          <div className="col-lg-3">
                            <h6 className="product-field-name">
                              امکانات و قابلیتها
                            </h6>
                          </div>
                          <div className="col-lg-9">
                            <div className="product-field-value">
                              پردازشگر FPGA 96 کیلوهرتز 54 بیتی نقطه شناور
                            </div>
                            <div className="product-field-value">
                              پیش تقویت کننده های میکروفون HDIA کلاس 1 TASCAM
                            </div>
                            <div className="product-field-value">
                              4 موتور FX استریو با افکت های ساده و بسیار کاربردی
                              برای مراسمات مذهبی و موسیقی
                            </div>
                            <div className="product-field-value">
                              رابط کاربری بسیار ساده و کاربردی TASCAM VIEW
                            </div>
                            <div className="product-field-value">
                              2 صفحه نمایش لمسی خازنی 7 اینچی با روشنایی LED
                              یکپارچه
                            </div>
                            <div className="product-field-value">
                              18 کلید قابل شخصی سازی برای 7 لایه فیدر سفارشی و 8
                              گروه DCA
                            </div>
                            <div className="product-field-value">
                              16 LCD مینی با نمایشگر LED رنگی و قابل شخصی سازی
                              بالای فیدرها
                            </div>
                            <div className="product-field-value">
                              قابلیت ضبط و پخش روی کارت SD یا درایو فلش USB
                            </div>
                            <div className="product-field-value">
                              پورت BASE-T اترنت با سرعت انتقال 1000 گیگابیتی و
                              پرتکل TCP/IP
                            </div>
                            <div className="product-field-value">
                              رابط داخلی Dante با 64 خروجی و 64 ورودی
                            </div>
                            <div className="product-field-value">
                              رابط صوتی USB با قابلیت ضبط مستقیم 32 خروجی با
                              کیفیت 96 کیلوهرتزی
                            </div>
                          </div>
                        </div>
                        <div className="row no-gutters product-field">
                          <div className="col-lg-3">
                            <h6 className="product-field-name">اقلام همراه</h6>
                          </div>
                          <div className="col-lg-9">
                            <div className="product-field-value">کابل برق</div>
                            <div className="product-field-value">
                              دفترچه راهنما
                            </div>
                          </div>
                        </div>
                      </div>
                    </div> */}

                    {/*<div class="tab-pane" id="product-comments">
						<div class="product-comments">
							<div eval="collect(169503381)" product-commenting auto-show>
								<if terms="nope">
									<div class="product-comments" id="comments">
										<loop src="" recursive="">
											<div class="media product-comment break-word" id="comment-169503381">
												<div class="d-flex ml-3 product-comment-avatar">
													<img src="?m=crop&w=100&h=100&q=high" class="product-comment-avatar-image">
												</div>
												<div class="media-body">
													<h5 class="product-comment-author">
														<img src='' class="product-comment-author-flag">
														<if terms="yep">
															<span class="product-comment-name">
																
															</span>
														</if>
														<if terms="nope">
															<a href="" rel="nofollow" target="_blank" class="product-comment-website">
																<span>
																	
																</span>
															</a>
														</if>
													</h5>
													<p class="product-comment-body break-word">
														
													</p>
													<span class="product-comment-time">
														<i class="fa fa-clock-o"></i>
														51 روز پیش
													</span>
													<a href="javascript:;" class="btn btn-sm btn-link product-comment-reply" ng-click="reply(169503381)">
														ارسال پاسخ
													</a>
													<if terms="yep">
														<div class="product-comment-rate text-warning">
															<span ng-repeat="number in [1,2,3,4,5]">
																<i class="fa fa-star product-comment-rate-icon" ng-class="{ 'fa-star-o': number > 5 }"></i>
															</span>
														</div>
													</if>
													<if terms="nope">
														<div class="product-comment-subset">
															
														</div>
													</if>
												</div>
											</div>
										</loop>
									</div>
								</if>
								<if terms="yep">
									<div class="product-commenting">
										<if terms="nope">
											<hr class="page-separator product-separator product-commenting-separator">
										</if>
										<h3 class="product-commenting-title">
											دیدگاه خود را بنویسید
										</h3>
										<form name="commenting" class="product-commenting-form" ng-submit="commenting.$valid && submit()" dynamic-form novalidate>
											<scope name="product-commenting">
												<div class="alert alert-danger validation-summary -failed" ng-if="validation" ng-class="{'d-block' : validation}">
    <h6 class="alert-heading text-xs validation-summary-title -failed-title">
  <span ng-bind="validation.main"></span>
    </h6>
    <ul class="validation-summary-list text-xxs -failed-list">
  <li class="validation-summary-item -failed-item" ng-repeat="(key, value) in validation" ng-if="key != 'main'">
      {{value}}
  </li>
    </ul>
</div>
											</scope>
											<div class="alert alert-success product-commenting-succeed" ng-show="succeed">
												<span ng-bind="succeed.description"></span>
											</div>
											<div class="product-commenting-reply-info" ng-show="isreply" ng-click="focusComment()">
												<div class="alert alert-warning">
													این دیدگاه به عنوان پاسخ شما به دیدگاهی دیگر ارسال خواهد شد. برای صرف نظر از ارسال این پاسخ، بر روی گزینه‌ی
													<u>انصراف</u> کلیک کنید.
												</div>
											</div>
											<div class="row">
												<div class="col-md-12">
													<div class="form-group product-commenting-body">
														<textarea id="productcomment-body" name="body" class="form-control product-commenting-body-input" rows="6" placeholder="بنویسید..." ng-model="model.body" ng-disabled="progress" required></textarea>
														<div class="validation-inline product-commenting-inline-error text-danger" ng-messages="commenting.body.$error" ng-show="commenting.$submitted || commenting.body.$dirty">
															<span ng-message="required">
																دیدگاه خود را بنویسید.
															</span>
															<span ng-message="server">
																<span ng-bind="validation.body"></span>
															</span>
														</div>
													</div>
												</div>
												<if terms="yep">
													<div class="col-md-6 col-lg-4">
														<div class="form-group product-commenting-name">
															<label for="productcomment-name" class="form-control-label product-commenting-name-label">
																نام و نام خانوادگی
															</label>
															<input type="text" id="productcomment-name" name="name" class="form-control product-commenting-name-input" ng-model="model.name" ng-disabled="progress">
															<div class="validation-inline product-commenting-inline-error text-danger" ng-messages="commenting.name.$error" ng-show="commenting.$submitted || commenting.name.$dirty">
																<span ng-message="server">
																	<span ng-bind="validation.name"></span>
																</span>
															</div>
														</div>
													</div>
													<div class="col-md-6 col-lg-4">
														<div class="form-group product-commenting-email">
															<label for="productcomment-email" class="form-control-label product-commenting-email-label">
																پست الکترونیک
															</label>
															<input type="text" id="productcomment-email" name="email" class="form-control product-commenting-email-input" ng-model="model.email" dir="ltr" ng-disabled="progress">
															<div class="validation-inline product-commenting-inline-error text-danger" ng-messages="commenting.email.$error" ng-show="commenting.$submitted || commenting.email.$dirty">
																<span ng-message="server">
																	<span ng-bind="validation.email"></span>
																</span>
															</div>
														</div>
													</div>
													<div class="col-md-6 col-lg-4">
														<div class="form-group product-commenting-website">
															<label for="productcomment-website" class="form-control-label product-commenting-website-label">
																آدرس وب‌سایت
															</label>
															<input type="text" id="productcomment-website" name="website" class="form-control product-commenting-website-input" ng-model="model.website" dir="ltr" ng-disabled="progress">
															<div class="validation-inline product-commenting-inline-error text-danger" ng-messages="commenting.website.$error" ng-show="commenting.$submitted || commenting.website.$dirty">
																<span ng-message="server">
																	<span ng-bind="validation.website"></span>
																</span>
															</div>
														</div>
													</div>
												</if>
												<if terms="yep">
													<div class="col-md-6 col-lg-4">
														<div class="form-group product-commenting-rate">
															<label for="productcomment-rate" class="form-control-label product-commenting-rate-label">
																امتیاز شما به محصول
															</label>
															<select id="productcomment-rate" name="rate" class="form-control product-commenting-rate-input" ng-model="model.rate" ng-disabled="progress">
																<option ng-value="1">یک ستاره</option>
																<option ng-value="2">دو ستاره</option>
																<option ng-value="3">سه ستاره</option>
																<option ng-value="4">چهار ستاره</option>
																<option ng-value="5">پنج ستاره</option>
															</select>
															<div class="validation-inline product-commenting-inline-error text-danger" ng-messages="commenting.rate.$error" ng-show="commenting.$submitted || commenting.rate.$dirty">
																<span ng-message="server">
																	<span ng-bind="validation.rate"></span>
																</span>
															</div>
														</div>
													</div>
												</if>
												<if terms="nope">
													<div class="col-md-12">
														دیدگاه شما از طرف
														<mark></mark> ارسال خواهد شد.
													</div>
												</if>
											</div>
											<button class="btn btn-primary product-commenting-submit" ng-disabled="progress" ng-hide="isreply">
												ارسال دیدگاه
											</button>
											<button class="btn btn-primary product-commenting-submit" ng-disabled="progress" ng-show="isreply">
												ارسال پاسخ
											</button>
											<button type="button" class="btn btn-link product-commenting-reset" ng-disabled="progress" ng-show="commenting.$dirty" ng-click="reset()" click-confirm="همه‌ی اطلاعات نوشته شده، حذف می‌شوند. آیا مطمئن هستید؟">
												انصراف
											</button>
											<div class="product-commenting-loading" ng-show="progress">
												<i class="fa fa-refresh fa-spin fa-fw"></i>
												کمی صبر کنید...
											</div>
										</form>
									</div>
								</if>
							</div>
						</div>
					</div>*/}
                  </div>
                </div>
              </div>
            </div>
          </main>
          {/*/main*/}
          {/*addtocart*/}
          <div
            id="product-addtocart-modal"
            className="modal product-addtocart-modal"
            tabIndex={-1}
            role="dialog"
          >
            <div
              className="modal-dialog product-addtocart-modal-dialog"
              role="document"
            >
              <div className="modal-content product-addtocart-modal-content">
                <div className="modal-header">
                  <h5 className="modal-title product-addtocart-modal-title">
                    انجام شد
                  </h5>
                  <button
                    type="button"
                    className="close product-addtocart-modal-close-icon"
                    data-dismiss="modal"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div className="modal-body product-addtocart-modal-body">
                  <h6 className="text-success product-addtocart-modal-headline">
                    محصول با موفقیت به سبدخرید اضافه شد.
                  </h6>
                  <p className="product-addtocart-modal-description">
                    برای ثبت نهایی سفارش بر روی دکمه‌ی
                    <i>مشاهده سبدخرید</i> کلیک کنید و برای افزودن دیگر محصولات
                    به سبدخرید خود، بر روی دکمه‌ی
                    <i>ادامه</i> کلیک کنید.
                  </p>
                </div>
                <div className="modal-footer">
                  <Link
                    to="/site/cart"
                    className="btn btn-primary product-addtocart-modal-link"
                  >
                    مشاهده سبدخرید
                  </Link>
                  <button
                    type="button"
                    className="btn btn-secondary product-addtocart-modal-close"
                    data-dismiss="modal"
                  >
                    ادامه
                  </button>
                </div>
              </div>
            </div>
          </div>
          {/* <div
            id="product-addtocart-modal"
            class="modal product-addtocart-modal show"
            tabindex="-1"
            role="dialog"
            aria-modal="true"
            style={{ paddingRight: "24.9875px", display: "block" }}
          >
            <div
              class="modal-dialog product-addtocart-modal-dialog"
              role="document"
            >
              <div class="modal-content product-addtocart-modal-content">
                <div class="modal-header">
                  <h5 class="modal-title product-addtocart-modal-title">
                    انجام شد
                  </h5>
                  <button
                    type="button"
                    class="close product-addtocart-modal-close-icon"
                    data-dismiss="modal"
                  >
                    <span aria-hidden="true">×</span>
                  </button>
                </div>
                <div class="modal-body product-addtocart-modal-body">
                  <h6 class="text-success product-addtocart-modal-headline">
                    محصول با موفقیت به سبدخرید اضافه شد.
                  </h6>
                  <p class="product-addtocart-modal-description">
                    برای ثبت نهایی سفارش بر روی دکمه‌ی
                    <i>مشاهده سبدخرید</i> کلیک کنید و برای افزودن دیگر محصولات
                    به سبدخرید خود، بر روی دکمه‌ی
                    <i>ادامه</i> کلیک کنید.
                  </p>
                </div>
                <div class="modal-footer">
                  <a
                    href="/site/cart"
                    class="btn btn-primary product-addtocart-modal-link"
                  >
                    مشاهده سبدخرید
                  </a>
                  <button
                    type="button"
                    class="btn btn-secondary product-addtocart-modal-close"
                    data-dismiss="modal"
                  >
                    ادامه
                  </button>
                </div>
              </div>
            </div>
          </div> */}
          {/*/addtocart*/}
        </div>

        {/*/quickview*/}
        {/*quickview*/}
        <form
          name="quickview"
          id="product-quickview-modal"
          className="modal modal-md product-quickview-modal"
          ng-submit="quickview.$valid && submit()"
          tabIndex={-1}
          role="dialog"
          quick-view
          dynamic-form
          noValidate
        >
          <div
            className="modal-dialog product-quickview-modal-dialog"
            role="document"
          >
            <div className="modal-content product-quickview-modal-content">
              <div className="modal-header">
                <h5 className="modal-title product-quickview-modal-title">
                  <span ng-bind="title" />
                </h5>
                <button
                  type="button"
                  className="close product-quickview-modal-close-icon"
                  data-dismiss="modal"
                >
                  <span aria-hidden="true">×</span>
                </button>
              </div>
              <div className="modal-body product-quickview-modal-body">
                <div
                  className="alert alert-danger validation-summary product-quickview-modal-failed m-0 mb-3"
                  ng-if="validation"
                  ng-class="{'d-block' : validation}"
                >
                  <h6 className="alert-heading validation-summary-title product-quickview-modal-failed-title">
                    <span ng-bind="validation.main" />
                  </h6>
                </div>
                <div
                  className="alert alert-success product-quickview-modal-succeed mb-0"
                  ng-show="succeed"
                >
                  <span ng-bind="succeed.description" />
                </div>
                <div ng-show="loading">در حال بارگذاری...</div>
                <div ng-hide="succeed || loading">
                  <div
                    className="form-group product-quickview-modal-attribute"
                    ng-repeat="attribute in attributes"
                  >
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">
                          {"{"}
                          {"{"}attribute.name{"}"}
                          {"}"}
                        </span>
                      </div>
                      <select
                        id="product-quickview-modal-attribute-{{$index}}"
                        name="attribute{{$index}}"
                        className="form-control product-quickview-modal-attribute-control"
                        ng-model="model.attributes['attribute' + $index]"
                        ng-change="changeAttribute()"
                        ng-disabled="progress"
                        required
                      >
                        <option
                          ng-repeat="value in attribute.values"
                          value="{{attribute.name}}: {{value}}"
                        >
                          {"{"}
                          {"{"}value{"}"}
                          {"}"}
                        </option>
                      </select>
                    </div>
                    <div
                      className="validation-inline product-quickview-modal-inline-error text-danger"
                      ng-messages="quickview['attribute' + $index].$error"
                      ng-show="quickview.$submitted || quickview['attribute' + $index].$dirty"
                    >
                      <span ng-message="required">
                        {"{"}
                        {"{"}attribute.name{"}"}
                        {"}"} را انتخاب کنید.
                      </span>
                    </div>
                  </div>
                  <div className="form-group product-quickview-modal-quantity">
                    <div className="input-group">
                      <div className="input-group-prepend">
                        <span className="input-group-text">تعداد</span>
                      </div>
                      <input
                        type="number"
                        id="product-quickview-modal-quantity"
                        name="quantity"
                        className="form-control product-quickview-modal-quantity-control"
                        ng-model="model.quantity"
                        ng-disabled="progress"
                        dir="ltr"
                        min={1}
                        max={1000000000}
                        required
                      />
                    </div>
                    <div
                      className="validation-inline product-quickview-modal-inline-error text-danger"
                      ng-messages="quickview.quantity.$error"
                      ng-show="quickview.$submitted || quickview.quantity.$dirty"
                    >
                      <span ng-message="required">تعداد را بنویسید.</span>
                      <span ng-message="min">
                        تعداد را بیش‌تر از 0 بنویسید.
                      </span>
                      <span ng-message="max">
                        تعداد را کم‌تر از 10000000000 بنویسید.
                      </span>
                    </div>
                  </div>
                  <span
                    className="product-quickview-modal-compare-price text-muted"
                    ng-show="getComparePrice()"
                  >
                    <del>
                      {"{"}
                      {"{"}getComparePrice() | number{"}"}
                      {"}"}
                    </del>
                  </span>
                  <span
                    className="product-quickview-modal-price text-green"
                    ng-show="getPrice()"
                  >
                    {"{"}
                    {"{"}getPrice() | number{"}"}
                    {"}"} تومان
                  </span>
                </div>
              </div>
              <div className="modal-footer" ng-hide="succeed || loading">
                <button
                  type="button"
                  className="btn btn-link product-quickview-modal-close"
                  ng-disabled="progress"
                  data-dismiss="modal"
                >
                  انصراف
                </button>
                <button
                  className="btn btn-success product-quickview-modal-submit"
                  ng-disabled="progress"
                >
                  افزودن به سبد خرید
                </button>
              </div>
            </div>
          </div>
        </form>
        {/*/quickview*/}
        {/*/quickview*/}
      </>
    );
};

export default ProductDetails;
